import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import data from '../../data/cidr5.json';

const ContributingFieldsBarChart = () => {
    //5_contributing_fields

    if (!Array.isArray(data)) {
        return <div>Loading chart...</div>;
    }

    const option = {
        title: {
            text: 'Top Contributing Fields by Frequency',
            left: 'center',
            textStyle: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow',
            },
            formatter: ({ 0: { name, value } }) => `${name}: ${value}`,
        },
        grid: {
            left: window.innerWidth <= 568 ? 0 : '2%',
            right: '5%',
            bottom: '5%',
            top: '15%',
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                formatter: '{value}',
                rotate: window.innerWidth <= 568 ? 45 : 0,
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        yAxis: {
            type: 'category',
            data: data.map(item => item.Field),
            inverse: true,
            axisLabel: {
                rotate: window.innerWidth <= 568 ? 45 : 0,
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        series: [
            {
                name: 'Frequency',
                type: 'bar',
                data: data.map(item => item.Frequency),
                itemStyle: {
                    color: '#10b981', // teal-500
                },
                label: {
                    show: true,
                    position: 'right',
                    color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 shadow">
            <ReactECharts option={option} style={{ height: 500 }} />
        </div>
    );
};

export default ContributingFieldsBarChart;
